import { useState } from 'react';
import { Warehouse, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '@/api/client';

export function MerchantWmsToggle({ merchantId, initial }: { merchantId: number; initial: boolean }) {
  const [enabled, setEnabled] = useState(!!initial);
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    const next = !enabled;
    setBusy(true);
    try {
      await api.patch(`/merchants/${merchantId}`, { wmsEnabled: next });
      setEnabled(next);
      toast.success(`WMS ${next ? 'enabled' : 'disabled'} for this merchant`);
    } catch (e: any) {
      toast.error(e?.response?.data?.message ?? 'Failed to update');
    } finally { setBusy(false); }
  };

  return (
    <div className="flex items-start gap-3 p-3 bg-slate-50 border border-slate-200 rounded-lg">
      <div className="w-9 h-9 rounded-lg bg-indigo-100 text-indigo-700 flex items-center justify-center"><Warehouse size={16} /></div>
      <div className="flex-1">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-medium text-sm">Warehouse Management (WMS)</div>
            <div className="text-xs text-slate-500">Shows a <b>view-only</b> WMS section in the merchant portal (Dashboard, Inventory, Products, GRN, Dispatch, RTO) scoped to <b>this merchant's own data only</b>.</div>
          </div>
          <button
            onClick={toggle} disabled={busy}
            className={`relative inline-flex items-center h-6 w-11 rounded-full transition-colors ${enabled ? 'bg-emerald-500' : 'bg-slate-300'}`}>
            <span className={`inline-block w-4 h-4 bg-white rounded-full shadow transform transition ${enabled ? 'translate-x-6' : 'translate-x-1'}`} />
            {busy && <Loader2 size={10} className="absolute -right-5 animate-spin text-slate-400" />}
          </button>
        </div>
      </div>
    </div>
  );
}
